import { IContentComponent } from "../Interfaces";

export class SaveContentComponentCommand {
  public ContentComponent: IContentComponent | null = null;
}